<template>
  <div ref="hanatourFooter" class="hanatour-footer"></div>
</template>

<script>
export default {
  props: {
    hanatourHost: String,
  },
  mounted() {
    this.$nextTick(() => {
      const postscribe = require('postscribe');
      const hanatourFooterEl = this.$refs.hanatourFooter;
      postscribe(
        hanatourFooterEl,
        `<script src="${this.hanatourHost}/fx/lib/webtour_footer.js"><\/script>`,
        {
          autoFix: false,
          done: () => {},
        }
      );
    });
  },
}
</script>

<style lang="scss" scoped>
.hanatour-footer {
  height: 100%;
  box-sizing: border-box;
}
</style>
